module.exports = __webpack_public_path__ + "static/2d_example-c3226161a19444845e41f0d9a9ff6622.jpg";